
var endpoint = window.location.hostname.match(/localhost/)  ? "/" : "/marketing/";
var token = "";

export function setEndpoint(url:string){
    endpoint = url;
}

export function setToken(newToken:string){
    localStorage.setItem('token', newToken);
    token = newToken;
}

export async function load(url: string, headers:Record<string, string> = {}, post: any = null, method: 'get' | 'post' | 'delete' | 'patch' = 'get'){
    if(token){
        headers = {"Authorization": `Bearer ${token}`, ...headers}
    }

    var options:RequestInit = {method};

    if(post){
        options = {
            method: method == 'get' ? "post" : method,
            body: JSON.stringify(post)
        }
        headers = {...headers, "Content-Type": "application/json"}
    }

    headers = {... headers, "Origin" : "localhost"}

    var res = await fetch(endpoint + url, {
        headers: headers,
        ... options
    });

    if(res.status != 200)
        throw await res.json();

    var data = await res.json();
    return data;
}

